import { computeCreateFolderMode, computeUploadMode } from './modes';
import { useFileManagerPermissions } from './useFileManagerPermissions';

// Single source for the permission-derived visibility of the Create-folder/Create-file menu
// entries — previously re-derived independently in four different files, all reading the same
// `permissions` ref. Deliberately named `showX`, not `canX`: `useFileManagerCreateFolder`'s and
// `useFileManagerUpload`'s own `canCreateFolderAt`/`canUploadTo` (and their `canCreateFolder`/
// `canUpload` currentPath shorthands) mean something different — whether the TARGET PATH has a
// writable drive behind it at all, which the virtual root and an intermediate namespace do not — and
// gate whether the action does anything when invoked, not whether the menu entry is shown. The two
// gates stay independent; menu call sites that would otherwise offer a guaranteed no-op combine
// them (`showCreateFolderAt(path) && canCreateFolderAt(path)`).
//
// Both take the path they are about rather than the composable taking one once: the two context-menu
// callers only learn their target inside the event handler, and the grid's item menu genuinely means
// the right-clicked row's path, not the folder currently open — at the virtual root those are
// different mounts (or no mount at all).
export const useFileManagerActionVisibility = () => {
  const { permissionsAt } = useFileManagerPermissions();
  return {
    showCreateFolderAt: (path: string) =>
      computeCreateFolderMode(permissionsAt(path)) === 'visible',
    showCreateFileAt: (path: string) =>
      computeUploadMode(permissionsAt(path)) === 'visible',
  };
};
